const startPage: Record<string, Record<string, string> | string> = {
    logoAlt: 'Inconsult K',
};

export default startPage;
